<template>
  <div id="top">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 bg-white pb-5">
          <p class="topMainImg">
            <img src="../assets/img/topVisual.jpg" alt="銀のすぷーん 店頭受取予約サイト" class="topMainImg__img" />
          </p>

          <div class="introduction">
            <div class="row">
              <div class="col-lg-7 about">
                <p class="text1">
                  こちらは銀のすぷーんのお菓子を、店頭受取予約できるページです。24時間ウェブで簡単に予約でき、<span
                    class="span"
                    >17時までにご注文頂ければ最短翌日にお渡しが可能</span
                  >です。<br />
                  <span class="span"
                    >当日のお受け取りやお急ぎの場合は、お電話にてご予約いただきますようお願いいたします。WEBでは承っておりません。</span
                  >
                </p>
              </div>
              <div class="col-lg-5 telInfo">
                <!-- <p class="bg-blue text-center">お電話でのご注文はこちら</p> -->
                <a href="tel:0942350092" class="bg-blue text-center d-inline-block" id="telBtn"
                  >お電話でのご注文はこちら</a
                >
                <p class="c-blue">0942-35-0092</p>
                <p class="telInfo__time">受付時間１０時〜１８時</p>
              </div>
            </div>
          </div>

          <!-- <div class="caution" style="margin-bottom:30px">
            <p class="caution__text1">システムメンテナンスのお知らせ</p>
            <p class="caution__text2">
              只今決済システムメンテナンスの為「シティプラザ店」の受取予約を停止しております。<br />
              その他店舗のご予約は引き続き受け付けておりますのでご利用くださいませ。<br />
              復旧時期：未定（数日〜数週間）
            </p>
          </div> -->

          <div class="caution">
            <p class="caution__text1">ご注文の際は下記にご注意ください</p>
            <p class="caution__text2">
              ※キャラクターケーキ、アレルギー対応ケーキは<span class="span">お受取の３日前までにお電話でのみ</span
              >承ります。<br />
              ※原材料の入荷状況によっては<span class="span">商品のご用意が難しい場合もございます。</span
              >ご了承下さいませ。<br />
              ※12月22日〜12月25日の期間は、<span class="span"
                >生ケーキ全種類（ホールケーキ・カットケーキ・シュークリーム・プリン等）のご予約は承っておりません。</span
              ><br />
              ※ご変更受付はお電話のみにて承ります。店頭では受付けておりませんので、ご了承ください。
            </p>
          </div>
          <p class="reservationTitle">本店・博多店での予約からお受け取りの流れ</p>
          <div class="iconCntainer">
            <div class="row iconRow">
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">1</span>
                  <p>
                    <img src="../assets/img/icon_01.png" srcset="../assets/img/icon_01.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">ご予約ページより予約します。</p>
              </div>
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">2</span>
                  <p class="icon2">
                    <img src="../assets/img/icon_02.png" srcset="../assets/img/icon_02.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">ご注文完了後にメールが届きます。</p>
              </div>
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">3</span>
                  <p class="icon3">
                    <img src="../assets/img/icon_03.png" srcset="../assets/img/icon_03.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">当日店頭にてお名前と、予約番号をお伝え下さい。</p>
              </div>
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">4</span>
                  <p>
                    <img src="../assets/img/icon_04.png" srcset="../assets/img/icon_04.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">ケーキお受け取りの際にお支払いをお願いいたします。</p>
              </div>
            </div>
          </div>

          <p class="reservationTitle">プラザ店(スマートショップ)でのお受け取りの流れ</p>
          <div class="iconCntainer">
            <div class="row iconRow">
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">1</span>
                  <p>
                    <img src="../assets/img/icon_01.png" srcset="../assets/img/icon_01.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">ご予約ページより予約します。</p>
              </div>
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">2</span>
                  <p class="icon2">
                    <img src="../assets/img/img_card.svg" srcset="../assets/img/img_card.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">クレジットカードにてお支払いください。</p>
              </div>
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">3</span>
                  <p class="icon3">
                    <img src="../assets/img/img_mail.svg" srcset="../assets/img/img_mail.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">ご注文完了後、QRコードと伝票番号が記載されたメールが届きます。</p>
              </div>
              <div class="col-6 col-lg-3 iconCol">
                <div class="iconBox">
                  <span class="number">4</span>
                  <p>
                    <img src="../assets/img/img_locker.svg" srcset="../assets/img/img_locker.svg" alt="" />
                  </p>
                </div>
                <p class="iconBox__desc">ロッカーでQRコードもしくは伝票番号を入力して商品をお受け取りください。</p>
              </div>
            </div>
          </div>

          <p class="text-center mb-4 presentMsg">
            ご予約特典　WEB予約の方1件につき、<br class="d-md-none" />ご来店時おすすめのパウンドケーキプレゼント中 !
            <!-- <small>※クリスマスケーキのご予約にはプレゼントはつきません</small> -->
          </p>
          <div class="btn_reserve">
            <a class="ec d-sm-none" href="https://ec.g-spoon.co.jp/" target="_blank">
              <span>おうちへ<br />お届け</span>
            </a>
            <a class="corporate d-sm-none" href="https://g-spoon.co.jp/" target="_blank">
              <span>公式サイト</span>
            </a>
            <router-link to="/reservation" class="btn btn_icon">
              <picture>
                <source type="image/svg+xml" srcset="../assets/img/btn_icon02.svg" />
              </picture>
              ご予約はこちら<i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <!-- <p class="xmasBtn">
            <a href="./event/" class="btn btn_icon">
              <img src="../assets/img/btn_icon01.png" srcset="../assets/img/btn_icon01@2x.png" alt="icon" />
              クリスマスケーキのご予約はこちら<i class="fas fa-chevron-right"></i>
            </a>
          </p> -->

          <div class="btn_external">
            <a class="ec d-none d-sm-block" href="https://ec.g-spoon.co.jp/" target="_blank">おうちへお届け</a>
            <a class="corporate d-none d-sm-block" href="https://g-spoon.co.jp/" target="_blank">公式サイト</a>
          </div>
          <!-- ドメイン拒否の注意書き -->
          <div class="domeinNotice">
            <h3 class="domeinNotice__ttl">各携帯会社のドメイン指定解除方法</h3>
            <p class="domeinNotice__txt">
              ｢ドメイン指定受信｣など，一部アドレスからのメールのみ許可する設定の手順は，各携帯電話会社によって異なります｡（詳しくはお手持ちの携帯電話の取り扱い説明書をご覧ください）
            </p>
            <p class="domeinNotice__txt">ドメイン指定受信を設定する場合は，以下のドメインを指定してください｡</p>
            <p class="domeinNotice__txt">弊社からの返信は｢web-order@g-spoon.co.jp｣の指定をお願い致します｡</p>
            <h3 class="domeinNotice__subTtl">ドメイン指定受信設定方法</h3>
            <dl class="list">
              <dt>Docomo</dt>
              <dd>
                iメニュー→オプション設定→メール設定→メール受信設定[受信/拒否設定]→ドメイン指定受信→受信したいドメインまたはアドレスの欄にドメイン｢g-spoon.co.jp｣または｢web-order@g-spoon.co.jp｣を入力→i-modeパスワードを入力→決定→設定完了
              </dd>
            </dl>
            <dl class="list mt-4 mb-4">
              <dt>SoftBank</dt>
              <dd>
                Yahoo!ケータイメニュー→My
                SoftBank→オリジナルメール設定･各種メール設定→暗証番号を入力→迷惑メール関連設定→受信拒否･許可アドレスの設定
                →受信｢許可ﾘｽﾄとして設定｣→[一括指定]
                または[個別アドレスの追加]→｢個別アドレスの追加｣するを選択ドメインを入力後，ドメイン｢g-spoon.co.jp｣または｢web-order@g-spoon.co.jp｣を選択→設定完了
              </dd>
            </dl>
            <dl class="list">
              <dt>au</dt>
              <dd>
                Eメールメニュー→Eメール設定→その他の設定→メールフィルター→暗証番号を入力→アドレスフィルター→個別設定[指定受信リスト設定→指定受信設定
                →【個別指定】にドメイン｢g-spoon.co.jp｣または｢web-order@g-spoon.co.jp｣を入力→設定完了
              </dd>
            </dl>
          </div>
          <!-- ドメイン拒否の注意書き -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top',
  mounted() {
    const pageHeaderCartBtn = document.getElementById('pageHeaderCartBtn')
    pageHeaderCartBtn.style.display = 'none'
    const pageHeaderCartBtn_first = document.getElementById('pageHeaderCartBtn_first')
    pageHeaderCartBtn_first.style.display = 'block'
  },
  updated() {
    const pageHeaderCartBtn = document.getElementById('pageHeaderCartBtn')
    pageHeaderCartBtn.style.display = 'none'
    this.radioResult = ''
    this.reservation.cart = []
    this.seenCart = false
    this.reservation.hiddenSum = 0
    this.reservation.tax = 0
    this.reservation.sum = 0
    this.reservation.count = 0
    this.reservation.showItemList = []
    this.reservation.itemList = []
    this.reservation.totalCartItemNumber = 0
  },
  head: {
    title: {
      inner: '福岡で誕生日ケーキ・洋菓子のテイクアウト',
      separator: '|',
      complement: '銀のすぷーん予約サイト'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.xmasBtn {
  margin-top: 30px;
  .btn {
    background: rgb(22, 84, 22);
  }
  @media (max-width: 575.98px) {
    position: fixed;
    display: block;
    width: 100%;
    left: 0;
    bottom: 70px;
    a {
      display: block;
    }
  }
}
#top {
  background-color: #fdf5e6;
  padding-top: 70px;
  padding-bottom: 70px;
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN', HGS明朝E, メイリオ, Meiryo, serif;
}
.btn_icon {
  img {
    max-width: 30px;
  }
}
.btn_other {
  margin: 30px 0 40px;
  background: #0d446f !important;
}
.btn_external {
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  a {
    display: block;
    text-align: center;
    background: #0d446f !important;
    color: #fff;
    padding: 1rem 0;
    width: 49%;
    border-radius: 5px;
    &:hover {
      text-decoration: none;
      opacity: 0.8;
    }
  }

  .ec {
    position: relative;

    &::before {
      content: '\f07a';
      font-family: 'Font Awesome 5 Free';
      font-weight: 600;
      right: 1.5rem;
      position: absolute;
      top: 25%;
    }
  }

  .corporate {
    position: relative;

    &::before {
      content: '\f54e';
      font-family: 'Font Awesome 5 Free';
      font-weight: 600;
      right: 1.5rem;
      position: absolute;
      top: 25%;
    }
  }
}
.span {
  font-weight: bold;
}
.topMainImg {
  margin-top: 80px;
  padding: 0 15px;
  @media (max-width: 767.98px) {
    margin-top: 70px;
  }
  &__img {
    max-width: 100%;
  }
}
.bg-blue {
  background: #0d446f;
  color: #fff;
  padding: 5px 20px;
  border-radius: 50px;
  font-size: 14px;
  margin-bottom: 10px;
  @media (max-width: 991.98px) {
    // width: 80%;
    margin: auto;
    margin-bottom: 10px;
  }
}
.c-blue {
  font-size: 36px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.89;
  letter-spacing: normal;
  text-align: center;
  color: #03365b;
  font-style: italic;
}
.introduction {
  padding: 0 15px;
  .text1 {
    text-align: left;
  }
  .telInfo {
    text-align: center;
    &__time {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.53;
      color: #333333;
      text-align: center;
    }
  }
}
.caution {
  border-radius: 5px;
  background-color: #f6f6f6;
  border: solid 1px #eeeeee;
  margin: 0 15px;
  padding: 0 15px;
  &__text1 {
    color: #c65c5c;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.28;
    margin-top: 17px;
    @media (max-width: 575.98px) {
      font-size: 16px;
    }
  }
  &__text2 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    text-align: left;
    color: #333333;
  }
}
.reservationTitle {
  font-size: 21px;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
  color: #ae952f;
  margin-top: 30px;
  margin-bottom: 42px;
}
.iconCntainer {
  padding: 0 15px;
  .iconBox {
    position: relative;
    border-radius: 5px;
    background-color: #f6f6f6;
    border: solid 1px #eeeeee;
    min-height: 130px;
    .number {
      position: absolute;
      top: -10px;
      left: 50%;
      margin-left: -10px;
      font-size: 36px;
      font-weight: 500;
      line-height: 0.64;
      text-align: center;
      color: #0d446f;
    }
    p {
      text-align: center;
      padding: 0 20px;
      margin-top: 40px;
    }
    .icon3 {
      margin-bottom: 5px;
    }
    &__desc {
      margin-top: 15px;
      margin-bottom: 30px;
    }
  }
}
.btn {
  position: relative;
  background-color: #831f17;
  color: #fff;
  display: block;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN', HGS明朝E, メイリオ, Meiryo, serif;
  font-size: 20px;
  line-height: 1.15;
  text-align: center;
  color: #ffffff;
  &:hover {
    opacity: 0.7;
  }
  i {
    position: absolute;
    top: 50%;
    right: 30px;
    margin-top: -0.6em;
    font-size: 20px;
    line-height: 1.15;
    font-weight: bold;
  }
}
//電話をかけるのボタン
#telBtn {
  &:hover {
    opacity: 0.7;
    text-decoration: none;
  }
}
//サクリスタンプレゼントメッセージ
.presentMsg {
  border: 1px #ecb2cb dashed;
  padding: 15px 10px;
  border-radius: 10px;
  line-height: 2;
}
// sp時に下部に固定
.btn_reserve {
  @media (max-width: 575.98px) {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: space-between;

    .ec,
    .corporate {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 20%;
      background-color: #0d446f;
      color: white;
      border-radius: 5px;
      text-align: center;
      font-size: 0.8rem;
      letter-spacing: -0.03rem;
      line-height: 1.3;
      padding: 2.5rem 0 0.5rem 0;
      position: relative;
    }

    .ec {
      &::before {
        content: '\f07a';
        font-family: 'Font Awesome 5 Free';
        font-weight: 600;
        position: absolute;
        font-size: 1.4rem;
        top: 0.5rem;
      }
    }

    .corporate {
      &::before {
        content: '\f54e';
        font-family: 'Font Awesome 5 Free';
        font-weight: 600;
        position: absolute;
        font-size: 1.4rem;
        top: 0.5rem;
      }
    }

    .btn {
      width: 59%;
      margin: 0 0 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1.5rem 0 !important;
      position: relative;

      .fa-chevron-right {
        padding-left: 1rem !important;
        display: inline-block;
        position: absolute;
        right: 1rem;
      }
    }
  }
}

// ドメイン拒否の注意書き
.domeinNotice {
  border-radius: 5px;
  background-color: #f6f6f6;
  border: solid 1px #eeeeee;
  padding: 15px;
  margin-top: 50px;
  &__ttl {
    color: #03365b;
    font-weight: bold;
    font-size: 20px;
  }
  &__txt {
    font-size: 14px;
  }
  &__subTtl {
    font-size: 16px;
    color: #03365b;
    border: #03365b 1px solid;
    display: inline-block;
    padding: 5px 15px;
  }
  .list {
    margin-top: 10px;
    dt {
      background: #0d446f;
      display: inline;
      color: #fff;
      padding: 4px 10px;
      border-radius: 5px;
      font-size: 15px;
    }
    dd {
      margin-top: 7px;
      font-size: 14px;
    }
  }
}

.maintenance-container {
  width: 100%;
  display: flex;
  justify-content: center;

  .maintenance-txt {
    color: red;
    font-size: 14px;
    /* text-align: center; */
    font-weight: 700;
    max-width: 640px;
    display: inline-block;
    padding: 0px 0 30px;
  }
}
</style>
